'use client'
import { LazyMotion, domAnimation, m } from 'framer-motion'

export default function Slogan() {
  const variants = {
    animate: {
      backgroundPosition: ['-2500px', '0'],
      transition: {
        backgroundPosition: {
          repeat: Infinity,
          repeatType: 'loop',
          duration: 100,
          ease: 'linear',
        },
      },
    },
  }

  return (
    <div className="py-2 md:pt-4 md:pb-3 overflow-hidden">
      <LazyMotion features={domAnimation}>
        <m.div
          variants={variants}
          animate="animate"
          className="h-[48px] md:h-[64px] w-full bg-[auto_100%] bg-repeat-x bg-[url('/images/about/we_ignite_your_heart.webp')]"
        />
      </LazyMotion>
    </div>
  )
}
